"use client"

import { useEffect } from "react"
import styled from "styled-components"
import useResponsive from "../hooks/useResponsive"

const MobileContainer = styled.div`
  /* Optimize for mobile performance */
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    /* Reduce animations on mobile */
    * {
      animation-duration: 0.3s !important;
      transition-duration: 0.3s !important;
    }
    
    /* Optimize transforms for mobile */
    .mobile-optimized {
      transform: translateZ(0);
      backface-visibility: hidden;
      perspective: 1000px;
    }
    
    /* Reduce blur effects on mobile */
    .blur-effect {
      filter: blur(5px) !important;
    }
    
    /* Hide complex animations on mobile */
    .complex-animation {
      display: none !important;
    }
  }
  
  /* Touch-friendly interactions */
  @media (hover: none) and (pointer: coarse) {
    button, a, [role="button"] {
      min-height: 44px;
      min-width: 44px;
      padding: 12px;
    }
    
    /* Remove hover effects on touch devices */
    .hover-effect:hover {
      transform: none !important;
      box-shadow: none !important;
    }
    
    /* Add active states for touch */
    .hover-effect:active {
      transform: scale(0.98);
      opacity: 0.8;
    }
  }
`

const MobileOptimized = ({ children }) => {
  const { isMobile } = useResponsive()

  useEffect(() => {
    if (isMobile) {
      // Disable smooth scrolling on mobile for better performance
      document.documentElement.style.scrollBehavior = "auto"

      // Add mobile-specific optimizations
      document.body.classList.add("mobile-optimized")
    } else {
      document.documentElement.style.scrollBehavior = "smooth"
      document.body.classList.remove("mobile-optimized")
    }

    return () => {
      document.body.classList.remove("mobile-optimized")
    }
  }, [isMobile])

  return <MobileContainer>{children}</MobileContainer>
}

export default MobileOptimized
